import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";

import utube from "../Images/utube.png";
import insta from "../Images/insta.png";
import fb from "../Images/fb.png";
import logo from "../Images/logo.svg";
import sendMetaEvent from "../Utils/metaTracking";

import {
  FaBars,
  FaTimes,
  FaChevronDown,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { treatments } from "../Data";

const fadeDown = {
  hidden: {
    opacity: 0,
    y: -20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      ease: "easeOut",
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      ease: "easeOut",
    },
  },
};

const logoAnimation = {
  hidden: {
    opacity: 0,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 1.4,
      ease: "easeOut",
    },
  },
};

const navContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.4,
    },
  },
};

const navItem = {
  hidden: {
    opacity: 0,
    y: 15,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.9,
      ease: "easeOut",
    },
  },
};

const Header = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
const [treatmentDropdown, setTreatmentDropdown] = useState(false);
const [mobileTreatmentDropdown, setMobileTreatmentDropdown] = useState(false);
  return (
    <>
      {/* TOP BAR */}

      <motion.div
        className="topbar"
        initial="hidden"
        animate="visible"
        variants={fadeDown}
      >
        <div className="container topbar-container">
          <p>Formerly known as "Shree Madhav Smaranam Ayurveda Clinic"</p>

          <div className="topbar-right">
            <a href="/contact-us">Contact us</a>

            <span>|</span>

            <p>Follow us :</p>

            <motion.a
              href="https://www.youtube.com/@dr.jigargor.ayurveda"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              whileHover={{
                y: -3,
                scale: 1.05,
              }}
              transition={{
                duration: 0.4,
              }}
            >
              <img
                src={utube}
                alt="Youtube Icon | Dr. Jigar Gor's Ayurveda"
              />
            </motion.a>

            <motion.a
              href="https://www.instagram.com/dr.jigargor.ayurveda/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              whileHover={{
                y: -3,
                scale: 1.05,
              }}
              transition={{
                duration: 0.4,
              }}
            >
              <img
                src={insta}
                alt="Instagram Icon | Dr. Jigar Gor's Ayurveda"
              />
            </motion.a>

            <motion.a
              href="https://www.facebook.com/dr.jigargor.ayurveda"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              whileHover={{
                y: -3,
                scale: 1.05,
              }}
              transition={{
                duration: 0.4,
              }}
            >
              <img
                src={fb}
                alt="Facebook Icon | Dr. Jigar Gor's Ayurveda"
              />
            </motion.a>
          </div>
        </div>
      </motion.div>

      {/* HEADER */}

      <motion.header
        className="main-header"
        initial="hidden"
        animate="visible"
        variants={fadeUp}
      >
        <div className="container header-container">
          <motion.div variants={logoAnimation}>
            <NavLink
              to="/"
              className="logo"
            >
              <img
                src={logo}
                alt="Dr. Jigar Gor's Ayurveda Logo"
              />
            </NavLink>
          </motion.div>

          <motion.nav
            className="main-nav"
            variants={navContainer}
            initial="hidden"
            animate="visible"
          >
            <motion.div variants={navItem}>
              <NavLink
                to="/"
                end
                className={({ isActive }) =>
                  isActive
                    ? "nav-link active-nav-link"
                    : "nav-link"
                }
              >
                Home
              </NavLink>
            </motion.div>

            <motion.div variants={navItem}>
              <NavLink
                to="/about-us"
                className={({ isActive }) =>
                  isActive
                    ? "nav-link active-nav-link"
                    : "nav-link"
                }
              >
                About us
              </NavLink>
            </motion.div>

            <motion.div variants={navItem}>
              <NavLink
                to="/prakruti-analysis"
                className={({ isActive }) =>
                  isActive
                    ? "nav-link active-nav-link"
                    : "nav-link"
                }
              >
                Prakruti Analysis
              </NavLink>
            </motion.div>

            <motion.div
  className="nav-dropdown"
  variants={navItem}
>
  <div className="treatment-nav">
    <NavLink
      to="/treatments"
      className={({ isActive }) =>
        isActive
          ? "nav-link active-nav-link"
          : "nav-link"
      }
    >
      Treatments
    </NavLink>

    <button
      className="dropdown-toggle-btn"
      onClick={() =>
        setTreatmentDropdown(!treatmentDropdown)
      }
      aria-label="Toggle Treatments menu"
    >
      <FaChevronDown />
    </button>
  </div>

  <div
    className={`dropdown-menu ${
      treatmentDropdown ? "show-dropdown" : ""
    }`}
  >
    {treatments.map((item, index) => (
      <NavLink
        key={index}
        to={`/treatments/${item.slug}`}
        className="dropdown-link"
      >
        {item.title}
      </NavLink>
    ))}
  </div>
</motion.div>

            <motion.div variants={navItem}>
              <NavLink
                to="/blog"
                className={({ isActive }) =>
                  isActive
                    ? "nav-link active-nav-link"
                    : "nav-link"
                }
              >
                Blogs
              </NavLink>
            </motion.div>

             <motion.div variants={navItem}>
              <NavLink
                to="/testimonials"
                className={({ isActive }) =>
                  isActive
                    ? "nav-link active-nav-link"
                    : "nav-link"
                }
              >
               Testimonials
              </NavLink>
            </motion.div>

            <motion.div variants={navItem}>
              <motion.a
                href="/book-appointment"
                className="nav-btn"
                whileHover={{
                  scale: 1.03,
                }}
                transition={{
                  duration: 0.4,
                }}
              >
                Book Appointment
              </motion.a>
            </motion.div>
          </motion.nav>

          <button
  className="mobile-menu-btn"
  onClick={() => setSidebarOpen(true)}
>
  <FaBars />
</button>
        </div>
      </motion.header>

      <div
  className={`mobile-sidebar ${
    sidebarOpen ? "open-sidebar" : ""
  }`}
>
  <button
    className="close-sidebar"
    onClick={() => setSidebarOpen(false)}
  >
    <FaTimes />
  </button>

  <img
    src={logo}
    alt="Logo"
    className="sidebar-logo"
  />

  <nav
  className={`sidebar-nav ${
    mobileTreatmentDropdown ? "dropdown-open" : ""
  }`}
>

    <NavLink
      to="/"
      onClick={() => setSidebarOpen(false)}
    >
      Home
    </NavLink>

    <NavLink
      to="/about-us"
      onClick={() => setSidebarOpen(false)}
    >
      About Us
    </NavLink>

    <NavLink
      to="/prakruti-analysis"
      onClick={() => setSidebarOpen(false)}
    >
      Prakruti Analysis
    </NavLink>

    {/* Mobile Treatments Dropdown */}

<div className="sidebar-treatment">
  <NavLink
    to="/treatments"
    onClick={() => setSidebarOpen(false)}
  >
    Treatments
  </NavLink>

  <button
    className="sidebar-dropdown-toggle"
    onClick={() =>
      setMobileTreatmentDropdown(
        !mobileTreatmentDropdown
      )
    }
    aria-label="Toggle Treatments menu"
  >
    <FaChevronDown />
  </button>
</div>

{mobileTreatmentDropdown && (
  <div className="sidebar-dropdown">
    {treatments.map((item, index) => (
      <NavLink
        key={index}
        to={`/treatments/${item.slug}`}
        onClick={() => setSidebarOpen(false)}
      >
        {item.title}
      </NavLink>
    ))}
  </div>
)}

    <NavLink
      to="/blog"
      onClick={() => setSidebarOpen(false)}
    >
      Blogs
    </NavLink>

    <NavLink
      to="/testimonials"
      onClick={() => setSidebarOpen(false)}
    >
     Testimonials
    </NavLink>

    <NavLink
      to="/contact-us"
      onClick={() => setSidebarOpen(false)}
    >
    Contact Us
    </NavLink>

    <NavLink
      to="/book-appointment"
      onClick={() => setSidebarOpen(false)}
      className="nav-btn"
    >
      Book Appointment
    </NavLink>

  </nav>

  {/* Contact */}

  <div className="sidebar-contact">

    <div className="sidebar-contact-item">
      <FaPhoneAlt />
      <a href="tel:+919099094847"
 onClick={() => sendMetaEvent("PhoneClick")}>
        +91 90990 94847
      </a>
    </div>

    <div className="sidebar-contact-item">
      <FaEnvelope />
      <a href="mailto:dr.jigargor@yahoo.com">
        dr.jigargor@yahoo.com
      </a>
    </div>

    <div className="sidebar-contact-item">
      <FaMapMarkerAlt />
      <span>
        Narayan Complex, Near Lohana Samaj Wadi,
                Madhapar - Tal. Bhuj-Kutch,
                Gujarat-370020
      </span>
    </div>

  </div>

  {/* Social Icons */}

  <div className="sidebar-socials">

    <a
      href="https://www.youtube.com/@dr.jigargor.ayurveda"
      target="_blank"
      rel="noreferrer"
    >
      <img src={utube} alt="Youtube" />
    </a>

    <a
      href="https://www.instagram.com/dr.jigargor.ayurveda/"
      target="_blank"
      rel="noreferrer"
    >
      <img src={insta} alt="Instagram" />
    </a>

    <a
      href="https://www.facebook.com/dr.jigargor.ayurveda"
      target="_blank"
      rel="noreferrer"
    >
      <img src={fb} alt="Facebook" />
    </a>

  </div>

</div>

{sidebarOpen && (
  <div
    className="sidebar-overlay"
    onClick={() => setSidebarOpen(false)}
  />
)}
    </>
  );
};

export default Header;